import { Injectable } from '@angular/core';
import { getApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore, collection, getDocs, writeBatch, doc } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class MachinesService {
  private firestore: Firestore;

  constructor() {
    const photoLavieApp: FirebaseApp = getApp('photolavie');
    this.firestore = getFirestore(photoLavieApp);
  }

  async getMachines(): Promise<any[]> {
    const db = this.firestore;
    const snapshot = await getDocs(collection(db, 'machines'));
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  }

  async updateMachineCountries(updates: Map<string, string>): Promise<number> {
    const db = this.firestore;
    const machinesCol = collection(db, 'machines');
    let updatedCount = 0;

    const updateArray = Array.from(updates.entries());
    const chunkSize = 450;

    for (let i = 0; i < updateArray.length; i += chunkSize) {
      const chunk = updateArray.slice(i, i + chunkSize);
      const batch = writeBatch(db);
      
      chunk.forEach(([docId, country]) => {
        const docRef = doc(machinesCol, docId);
        batch.set(docRef, { Country: country }, { merge: true });
      });

      await batch.commit();
      updatedCount += chunk.length;
    }
    return updatedCount;
  }
}
